import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class TenantService {
    private _tenantName: string = environment.tenant || 'dusbam';

    constructor() {}

    get tenantName(): string {
        return this._tenantName;
    }
}
